const AlarmTypes = {
	GENERIC_ALARM: 'GENERIC_ALARM',
	SOS: 'SOS',
	MAN_DOWN: 'MAN DOWN',
	RIPCORD: 'RIPCORD',
	AMBER_SERVER: 'AMBER_SERVER',
	AMBER: 'AMBER'
};

export default AlarmTypes;